import React, { useState } from 'react'
import MainStore from '../components/Store/MainStore'
import Footer from '../components/Footer'
import StoreProducts from '../components/Store/StoreProducts'
import Navbar from '../components/Navbar'

const Store = () => {

  const [searchTerm, setSearchTerm] = useState("");

  const onSearch = (value) => {
    setSearchTerm(value);
  };

  return (
    <div>
      <Navbar />
      <MainStore setSearchTerm={setSearchTerm} />
      <StoreProducts searchTerm={searchTerm}/>
      <Footer />
    </div>
  )
}

export default Store